import { kampanyalar, type Kampanya } from "@/mocks/kampanyalar";

interface KampanyaVitriniProps {
  onDetayClick: (kampanya: Kampanya) => void;
}

export default function KampanyaVitrini({ onDetayClick }: KampanyaVitriniProps) {
  return (
    <section id="kampanyalar" className="py-20 md:py-28 bg-[#F7F3EE]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-[#1A0F0A] text-[#E8B86D] text-xs font-bold px-5 py-2 rounded-full tracking-[0.2em] uppercase mb-5">
            Özel Fırsatlar
          </span>
          <h2
            className="font-black italic text-[#1A0F0A] leading-tight mb-4"
            style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: "clamp(2rem, 5vw, 3.8rem)",
            }}
          >
            Size Özel Hazırlanmış
            <br />
            <span
              style={{
                background: "linear-gradient(135deg, #C9943A 0%, #E8B86D 50%, #C9943A 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              Kampanyalar
            </span>
          </h2>
          <p className="text-[#6B5D52] text-base md:text-lg max-w-xl mx-auto font-light">
            Her bütçeye ve ihtiyaca uygun premium güzellik paketlerimizi keşfedin
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
          {kampanyalar.map((k, idx) => (
            <div
              key={k.id}
              className={`rounded-2xl overflow-hidden group hover:-translate-y-2 transition-all duration-300 cursor-pointer ${
                idx === 0
                  ? "bg-[#1A0F0A] border border-[#E8B86D]/30"
                  : "bg-white border border-[#EDE5D8]"
              }`}
            >
              {/* Image */}
              <div className="relative overflow-hidden h-52">
                <img
                  src={k.gorsel}
                  alt={k.baslik}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className={`absolute inset-0 ${idx === 0 ? "bg-gradient-to-t from-[#1A0F0A]/60 to-transparent" : "bg-gradient-to-t from-black/20 to-transparent"}`} />
                <div className="absolute top-3 left-3">
                  <span className="bg-[#E8B86D] text-[#1A0F0A] text-xs font-bold px-3 py-1 rounded-full">
                    {k.etiket}
                  </span>
                </div>
                {/* İndirim rozeti */}
                <div className="absolute top-3 right-3">
                  <span className={`text-xs font-bold px-2.5 py-1 rounded-full ${idx === 0 ? "bg-white/20 text-white backdrop-blur-sm" : "bg-[#1A0F0A]/80 text-[#E8B86D]"}`}>
                    %{Math.round((1 - parseInt(k.yeniFiyat.replace(/\D/g, '')) / parseInt(k.eskiFiyat.replace(/\D/g, ''))) * 100)} İndirim
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3
                  className={`text-xl font-bold italic mb-2 ${idx === 0 ? "text-white" : "text-[#1A0F0A]"}`}
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  {k.baslik}
                </h3>
                <p className={`text-sm leading-relaxed mb-5 font-light ${idx === 0 ? "text-white/65" : "text-[#7A6B5E]"}`}>
                  {k.aciklama}
                </p>

                {/* Price */}
                <div className="flex items-end gap-3 mb-5">
                  <span className={`text-sm line-through ${idx === 0 ? "text-white/35" : "text-[#B0A090]"}`}>{k.eskiFiyat}</span>
                  <span
                    className="text-2xl font-black italic"
                    style={{
                      fontFamily: "'Playfair Display', serif",
                      background: "linear-gradient(135deg, #C9943A, #E8B86D)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundClip: "text",
                    }}
                  >
                    {k.yeniFiyat}
                  </span>
                </div>

                {/* CTA */}
                <button
                  onClick={() => onDetayClick(k)}
                  className={`w-full font-bold py-3 rounded-xl text-sm transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2 ${
                    idx === 0
                      ? "bg-[#E8B86D] text-[#1A0F0A] hover:bg-[#F5D08A]"
                      : "bg-[#1A0F0A] text-white hover:bg-[#2D1810]"
                  }`}
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  Detaylı İncele
                  <i className="ri-arrow-right-line" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}